import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ProposalService } from '../services/proposal.service';

@Component({
  selector: 'notes-dialog',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './notes.component.html',
  styleUrl: './notes.component.scss',
})
export class NotesComponent {
  _active: boolean = false;
  @Input() set active(value: boolean) {
    this._active = value;
    if (value) this.isSubmitting = false;
  }
  get active() { return this._active; }

  @Output() modalClosed = new EventEmitter<boolean>();
  @Input() data: any = {};
  @Input() bidNotes: string = '';
  @Output() saveBidNotes = new EventEmitter<any>();

  @Input() siteType: string = '';
  @Input() siteSubType: string = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };

  isSubmitting = false;

  constructor(private proposalService: ProposalService) {}

  ngOnInit() {
    this.bidNotes = this.data?.proposal?.bidNotes;
  }

  closeDialog() {
    this.active = false;
    this.bidNotes = this.data.proposal.bidNotes;
    this.modalClosed.emit(this.active);
  }

  submit() {
    this.isSubmitting = true;
    this.saveBidNotes.emit({
      fieldName: 'bidNotes',
      value: this.bidNotes,
    });
  }
}
